module.exports = __webpack_public_path__ + "static/media/garderobe.fb711631.jpg";